import { requireModule } from '../../auth/guards';
import { MODULES } from '../../auth/permissions';
import FilesPage from './pages/FilesPage';

export const filesRoutes = [
  {
    path: '/files',
    element: <FilesPage />,
    handle: { breadcrumb: 'Files' },
    loader: requireModule(MODULES.FILES),
  },
];
